import { jsx } from "../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { computeInputProps, computeLabelProps } from "./utils/text-field-functions.es.js";
import MUITextField from "../../../node_modules/@mui/material/TextField/TextField.es.js";
function TextField({
  size,
  readonly,
  disabled,
  blocked,
  startIcon,
  endIcon,
  startAdornment,
  endAdornment,
  onStartIconClick,
  onStartAdornmentClick,
  onEndIconClick,
  onEndAdornmentClick,
  InputProps,
  InputLabelProps,
  ...rest
}) {
  const isTextFieldDisabled = readonly ?? disabled ?? blocked;
  return /* @__PURE__ */ jsx(MUITextField, { size: size ?? "medium", variant: "outlined", disabled: isTextFieldDisabled, InputProps: computeInputProps({
    size,
    readonly,
    blocked,
    startIcon,
    endIcon,
    startAdornment,
    endAdornment,
    onStartIconClick,
    onEndIconClick,
    onStartAdornmentClick,
    onEndAdornmentClick,
    InputProps
  }), InputLabelProps: computeLabelProps({
    readonly,
    InputLabelProps
  }), ...rest });
}
export {
  TextField
};
//# sourceMappingURL=text-field.es.js.map
